
<template>
  <div class="error-msg">
    <img src="@/assets/base-error-img.png" alt="">
    {{ errorMsg }}
  </div>
</template>
<script>
  export default {
    name: "ErrorMsg",
    props: {
      errorMsg: {
        type: String,
        default: ""
      }
    },
    data() {
      return {};
    },
    mounted() {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
.error-msg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  font-size: 16px;
  color: #fff;
  img {
    width: 240px;
    height: 240px;
    margin-bottom: 10px;
  }
}
</style>
